
































import {Vue, Component} from "vue-property-decorator";
import MyForm from "../MyForm";
import router from "../router";
import axios from "axios";


@Component({})
export default class ForGetPassword extends Vue {
    public form = new MyForm({
        email: "",
    });


    sendCode() {
        axios.post('api/forget-password', this.form)
            .then(({data}) => {
                // console.log('password reset data', data)
                router.replace({name: 'ResetPassword'})
            }).catch(error => {
            this.form.error = error.response.data.errors;
            // console.log('password reset error', error)
        })
    }
}
